import { format, parse } from 'date-fns';

export function FormatStringAsShortDate(string: string | null | undefined): string | null {
	if (string == null) return null;

	var date = new Date(string);

	return format(date, 'MM/dd/yyyy');
}

export function FormatStringAsDateAndTime(string: string | null | undefined): string | null {
	if (string == null) return null;

	var date = new Date(string);

	return format(date, 'MM/dd/yyyy hh:mm');
}

export function FormatDateTimeStringWithAmPm(string: string | null | undefined): string | null {
	if (string == null) return null;

	var date = new Date(string);

	return format(date, 'MM/dd/yyyy hh:mm aa');
}

export function ParseDate(string: string | null | undefined): Date | null {
	if (string == null) return null;

	return new Date(string);
}

interface TimeZone {
	name: string;
	abbreviation: string;
}

const timeZones: TimeZone[] = [
	{ name: 'Eastern Standard Time', abbreviation: 'EST' },
	{ name: 'Central Standard Time', abbreviation: 'CST' },
	{ name: 'Mountain Standard Time', abbreviation: 'MST' },
	{ name: 'Pacific Standard Time', abbreviation: 'PST' },
	{ name: 'Alaskan Standard Time', abbreviation: 'AKST' },
	{ name: 'Hawaiian Standard Time', abbreviation: 'HST' },
	{ name: 'Atlantic Standard Time', abbreviation: 'AST' },
	{ name: 'Central Daylight Time', abbreviation: 'CDT' },
	{ name: 'Mountain Daylight Time', abbreviation: 'MDT' },
	{ name: 'Pacific Daylight Time', abbreviation: 'PDT' },
	{ name: 'Alaskan Daylight Time', abbreviation: 'AKDT' },
];

export function GetTimeZoneAbbreviation(timeZoneName: string): string {
	const timeZone = timeZones.find(tz => tz.name.toLowerCase().includes(timeZoneName.toLowerCase()));
	return timeZone ? timeZone.abbreviation : timeZoneName;
}

export function DisplayDateOnly(string: string | null | undefined): string | null {
	if (string == null) return null;

	var parts = string.split('-');
	if (parts.length < 2) return string;

	return `${parts[1]}/${parts[2]}/${parts[0]}`;
}

export function ParseDateOnly(string: string | null | undefined): Date | null {
	if (string == null) return null;

	return parse(string, 'yyyy-MM-dd', new Date());
}

export function validateDateWithinPlusMinus100Years(value: Date | string | null, fieldLabel: string): string | undefined {
	if (!value) return undefined;

	const date = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(date.getTime())) return `${fieldLabel} is invalid.`;

	const today = new Date();
	today.setHours(0, 0, 0, 0);

	const min = new Date(today);
	min.setFullYear(today.getFullYear() - 100);

	const max = new Date(today);
	max.setFullYear(today.getFullYear() + 100);

	date.setHours(0, 0, 0, 0);

	if (date < min || date > max) {
		return `${fieldLabel} must be within 100 years of today.`;
	}

	return undefined;
}